/** Existing Pad command facts, shared without importing the local order runtime. */
export interface MealDrinkResolutionCommand{
  readonly submissionId:string;readonly groupId:string;readonly choiceId:string;
  readonly expectedUpdatedAt:string;readonly paymentConfirmed?:boolean;
  readonly expectedDeltaMinor:number;
  readonly expectedConfigFingerprint:string;
  readonly tender?:string;
  readonly optionSelections?:Readonly<Record<string,readonly string[]>>;
}
export interface MealDrinkResolutionRecord{
  readonly submissionId:string;readonly signature:string;readonly groupId:string;readonly choiceId:string;
  readonly createdAt:string;readonly priceDeltaMinor:number;readonly receivedMinor:number;readonly refundId?:string;
  readonly printState:'NOT_REQUIRED'|'ATTEMPTED'|'DONE'|'FAILED'|'UNKNOWN';
}
export type MobileDrinkResolution=Pick<MealDrinkResolutionCommand,'groupId'|'choiceId'|'expectedUpdatedAt'|'expectedDeltaMinor'|'expectedConfigFingerprint'|'optionSelections'>;
/** This command cannot carry a payment confirmation or a tender. */
export function mobileDrinkResolution(value:unknown):MobileDrinkResolution{
  const v=value as MobileDrinkResolution;
  if(!v||typeof v!=='object'||Array.isArray(v)||Object.keys(v).some(key=>!['groupId','choiceId','expectedUpdatedAt','expectedDeltaMinor','expectedConfigFingerprint','optionSelections'].includes(key))||![v.groupId,v.choiceId,v.expectedConfigFingerprint].every(item=>typeof item==='string'&&item.trim())||typeof v.expectedUpdatedAt!=='string'||!Number.isFinite(Date.parse(v.expectedUpdatedAt))||!Number.isSafeInteger(v.expectedDeltaMinor))throw Error('MEAL_DRINK_INPUT_INVALID');
  let optionSelections:Record<string,readonly string[]>|undefined;
  if(v.optionSelections!==undefined){
    if(!v.optionSelections||typeof v.optionSelections!=='object'||Array.isArray(v.optionSelections))throw Error('MEAL_DRINK_INPUT_INVALID');
    optionSelections={};
    for(const key of Object.keys(v.optionSelections).sort()){
      const ids=v.optionSelections[key];if(!key.trim()||!Array.isArray(ids)||!ids.every(id=>typeof id==='string'&&id.trim()))throw Error('MEAL_DRINK_INPUT_INVALID');
      Object.defineProperty(optionSelections,key,{value:Object.freeze([...ids]),enumerable:true});
    }
    Object.freeze(optionSelections);
  }
  return Object.freeze({groupId:v.groupId,choiceId:v.choiceId,expectedUpdatedAt:v.expectedUpdatedAt,expectedDeltaMinor:v.expectedDeltaMinor,expectedConfigFingerprint:v.expectedConfigFingerprint,...(optionSelections?{optionSelections}:{})});
}
